<script lang="ts">
    import { dictionary } from "@app/services/currentDictionary.service";

    function updateElementTextContent(
        newTextContent: string,
        newDataLangcode: string
    ) {
        return (element: HTMLElement) => {
            element.textContent = newTextContent;
            element.dataset["languagecode"] = newDataLangcode;
        };
    }

    let { l1, l2 } = $dictionary;
    $: {
        if (l1 !== $dictionary.l1) {
            l1 = $dictionary.l1;
            document
                .querySelectorAll(
                    "span.dictionary__source__name, div.dictionary__source__name"
                )
                .forEach(
                    updateElementTextContent(
                        l1.nameForDictionarySource || l1.name,
                        l1.code
                    )
                );
        }
        if (l2 !== $dictionary.l2) {
            l2 = $dictionary.l2;
            document
                .querySelectorAll(
                    "span.dictionary__target__name, div.dictionary__target__name"
                )
                .forEach(updateElementTextContent(l2.name, l2.code));
        }
    }
</script>
